<template>
  <loader :is-loading="isLoading" :reset-btn="false">
    <custom-drawer
      :icon="generateMessage('logbook.icon')"
      is-search
      :title="currentProperty.code"
      :subtitle="currentProperty.name"
      is-pagination
      is-date-filter
      namespace="logbook"
    >
      <template v-slot:content>
        <div>
          <div class="mt-2" v-for="(origin, index) in origins" :key="index">
            <div class="d-flex">
              <div
                class="font-weight-bold text-no-wrap"
                style="width: min-content"
              >
                {{ origin.description }}
              </div>
              <v-checkbox
                :input-value="isGroupChecked(origin.id)"
                dense
                @change="handleGroupCheckedClick(origin.id)"
                class="ma-0 pa-0"
                hide-details
              />
              <v-chip small class="mx-0">
                {{ itemsHasAttributeValueNumber('origin_id', origin.id) }}
              </v-chip>
            </div>
            <div
              class="d-inline-flex align-center"
              v-for="(pay, index) in subTypes(origin.id)"
              :key="index"
            >
              <v-checkbox
                class="ma-0 pa-0"
                hide-details
                dense
                v-model="selected"
                :label="pay.name"
                :value="pay.id"
              />
              <v-chip x-small class="mx-2">
                {{ itemsHasAttributeValueNumber('payload_type_id', pay.id) }}
              </v-chip>
            </div>
          </div>
        </div>
      </template>
    </custom-drawer>
  </loader>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Maths from '@/business/utils/maths';
import CustomDrawer from '@/components/boilerplate/RightSideBar/CustomDrawer';
import Loader from '@/components/widgets/Loader';
import { generateMessage } from '@/utils/i18n';

const { mapGetters, mapActions } = createNamespacedHelpers('logbook');

export default {
  name: 'logbook-filter',
  components: { Loader, CustomDrawer },
  data() {
    return {
      isDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      origins: 'origins/items',
      attributesObj: 'attributesObj',
      isLoading: 'isLoadingAttributesObjRef',
      payloadTypesOrigin: 'payloadTypes/payloadTypesOrigin',
      payloadTypes: 'payloadTypes/items',
      itemsHasAttributeValueNumber: 'itemsHasAttributeValueNumber',
      isAttributesObjEqualToRef: 'isAttributesObjEqualToRef',
    }),
    currentProperty: {
      get() {
        return this.$store.getters['properties_360/current'];
      },
    },
    selected: {
      get() {
        return this.attributesObj.payload_type_id.values;
      },
      set(val) {
        this.setLogbookPayloadsFilter(val);
      },
    },
  },
  methods: {
    generateMessage,
    ...mapActions(['setFilterAttribute']),
    subTypes(originId) {
      if (![3, 2].includes(originId)) return this.payloadTypesOrigin(originId); // exclude 'Demande d'intervention' et 'Hypervision Energétique'
      return null;
    },
    setLogbookPayloadsFilter(values) {
      this.setFilterAttribute({
        attribute: 'payload_type_id',
        values,
        useDelay: true,
      });
    },
    isGroupChecked(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      return Maths.arrayContainsArray(this.selected, idx);
    },
    checkGroup(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      this.setLogbookPayloadsFilter([...new Set(idx.concat(this.selected))]);
    },
    unCheckGroup(originId) {
      const idx = this.payloadTypesOrigin(originId).map((item) => item.id);
      this.setLogbookPayloadsFilter(
        Maths.arrayRemoveValues(this.selected, idx)
      );
    },
    handleGroupCheckedClick(originId) {
      if (this.isGroupChecked(originId)) {
        this.unCheckGroup(originId);
      } else {
        this.checkGroup(originId);
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
